
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gift-cards/redeem",
      function () {
        return require("private-next-pages/gift-cards/redeem.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gift-cards/redeem"])
      });
    }
  